/**
 * Banner shown when user navigated from Tax Forms (e.g. via Add Data links).
 * Provides a clear way to return to the exact tab they were on.
 */
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TAB_LABELS = {
  overview: 'Overview',
  'filing-info': 'Filing Info',
  '1040': 'Form 1040',
  'schedule-e': 'Schedule E',
  adjustments: 'Manual Adjustments'
};

const BackToTaxFormsBanner = () => {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const tab = searchParams.get('tab');
  if (from !== 'tax-forms' || !tab) return null;
  const label = TAB_LABELS[tab] || tab;
  return (
    <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg py-2 px-4 flex items-center gap-2">
      <Link
        to={`/tax-forms?tab=${tab}`}
        className="inline-flex items-center gap-2 text-blue-700 hover:text-blue-900 font-medium"
      >
        <ArrowLeft className="h-4 w-4" />
        <FileText className="h-4 w-4" />
        Back to Tax Forms ({label})
      </Link>
    </div>
  );
};

export default BackToTaxFormsBanner;
